import { useMemo } from 'react';

const useResponsiveGrid = (participantCount, chatOpen, containerWidth) => {
  return useMemo(() => {
    // Calculate available width (subtract chat drawer width if open)
    const chatDrawerWidth = chatOpen ? 400 : 0;
    const availableWidth = containerWidth - chatDrawerWidth;
    
    const gap = 12;
    const padding = 16;
    
    // Modern grid calculations with improved layouts
    let columns, maxColumns, tileWidth, tileHeight;
    
    // Determine optimal grid layout based on participant count
    if (participantCount === 1) {
      // Single participant: Large centered tile (70-80% width)
      columns = 1;
      maxColumns = 1;
      tileWidth = Math.min(availableWidth * 0.75, 800);
      tileHeight = tileWidth * (9 / 16);
    } else if (participantCount === 2) {
      // Two participants: Side-by-side equal split
      columns = 2;
      maxColumns = 2;
      const availableTileWidth = availableWidth - (padding * 2) - (gap * 1);
      tileWidth = availableTileWidth / 2;
      tileHeight = tileWidth * (9 / 16);
    } else if (participantCount <= 4) {
      // 3-4 participants: 2x2 grid
      columns = 2;
      maxColumns = 2;
      const availableTileWidth = availableWidth - (padding * 2) - (gap * 1);
      tileWidth = availableTileWidth / 2;
      tileHeight = tileWidth * (9 / 16);
    } else if (participantCount <= 6) {
      // 5-6 participants: 3x2 grid
      columns = 3;
      maxColumns = 3;
      const availableTileWidth = availableWidth - (padding * 2) - (gap * 2);
      tileWidth = availableTileWidth / 3;
      tileHeight = tileWidth * (9 / 16);
    } else if (participantCount <= 9) {
      // 7-9 participants: 3x3 grid
      columns = 3;
      maxColumns = 3;
      const availableTileWidth = availableWidth - (padding * 2) - (gap * 2);
      tileWidth = availableTileWidth / 3;
      tileHeight = tileWidth * (9 / 16);
    } else if (participantCount <= 16) {
      // 10-16 participants: 4x4 grid
      columns = 4;
      maxColumns = 4;
      const availableTileWidth = availableWidth - (padding * 2) - (gap * 3);
      tileWidth = availableTileWidth / 4;
      tileHeight = tileWidth * (9 / 16);
    } else {
      // 17+ participants: Auto-fit with max 5 columns
      columns = 'auto-fit';
      maxColumns = 5;
      const availableTileWidth = availableWidth - (padding * 2) - (gap * 4);
      tileWidth = Math.max(availableTileWidth / 5, 200); // Min width 200px
      tileHeight = tileWidth * (9 / 16);
    }
    
    const isAutoFit = columns === 'auto-fit';
    const minTileWidth = 200;
    
    return {
      columns,
      maxColumns,
      tileWidth: isAutoFit ? minTileWidth : tileWidth,
      tileHeight: isAutoFit ? minTileWidth * (9 / 16) : tileHeight,
      gap,
      padding,
      availableWidth,
      isAutoFit,
      participantCount
    };
  }, [participantCount, chatOpen, containerWidth]);
};

export default useResponsiveGrid;

